import React from 'react'
import userService from '../Service/userService'
import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'
export default class register extends React.Component {
  biodataModel = {
    fullname: "",
    mobile_phone: "",
    image: ""
  }

  userModel = {
    biodata_id: "",
    role_id: "",
    email: "",
    password: "",
    retype_pass: "",
    otp: ""
  }
  constructor() {
    super()
    this.state = {
      Model: this.userModel,
      Biodata: this.biodataModel,
      errors: {},
      showModalOtp: false,
      showModalPass: false,
      ShowModalBio: false,
      token: {},
      time: 0,
      minutes: 0,
      second: 0,
      displayCount: '',
      displaySend: 'none',
      ListRole: [],
      listToken: [],
      disabled: false,
      showModalLoad: false
    }
    this.timer = 0
  }

  updateCountdown() {
    const { time } = this.state
    if (time == 0) {
      clearInterval(this.interval)
      this.setState({
        displayCount: 'none',
        displaySend: ''
      })
    }
    let minutes = Math.floor(time / 60)
    let second = time % 60;
    second = second < 10 ? '0' + second : second
    minutes = minutes < 10 ? '0' + minutes : minutes
    this.setState({
      minutes: minutes,
      second: second,
      time: this.state.time - 1
    })
  }

  changeHandler = field => ({ target: { value } }) => {
    this.setState({
      Model: {
        ...this.state.Model,
        [field]: value
      }
    })
  }

  changeHandlerBio = field => ({ target: { value } }) => {
    this.setState({
      Biodata: {
        ...this.state.Biodata,
        [field]: value
      }
    })
  }

  cancelHandler = () => {
    this.setState({
      showModalOtp: false,
      errors: {}
    })
  }

  cancelHandlerPass = () => {
    this.setState({
      showModalPass: false,
      errors: {}
    })
  }
  cancelHandlerBio = () => {
    this.setState({
      ShowModalBio: false,
      errors: {}
    })
  }

  onSignUp = async () => {
    this.setState({
      disabled:true
    })
    const responEmail = await userService.cekEmail(this.state.Model.email)
    var email = ""
    if (responEmail.success) {
      this.setState({
        disabled:false
      })
      if (responEmail.result != undefined) {
        email = responEmail.result.email
      }
    }
    if (this.handleValidationSignUp(email)) {
      this.setState({
        showModalLoad: true
      }, () => {
        this.sendOtp()
        this.props.cancelRegHandler()
      })

    }
  }

  handleValidationSignUp = (cekemail) => {
    let fields = this.state.Model;
    let errors = {};
    let formIsValid = true;

    if (cekemail) {
      formIsValid = false;
      errors["Email_NotReady"] = "Email Already Use";
    }

    //Name
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Cannot be empty";
    }
    if (typeof fields["email"] !== "undefined") {
      let lastAtPos = fields["email"].lastIndexOf('@');
      let lastDotPos = fields["email"].lastIndexOf('.');

      if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') == -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
        formIsValid = false;
        errors["email"] = "Email is not valid";
      }
    }

    this.setState({ errors: errors });
    return formIsValid;
  }


  handleValidationOTP = () => {
    let fields = this.state.Model;
    let fields2 = this.state.token
    let errors = {};
    let formIsValid = true;



    //Name
    if (!fields["otp"]) {
      formIsValid = false;
      errors["otp"] = "Cannot be empty";
    }

    if (fields["otp"] != fields2['token']) {
      formIsValid = false;
      errors["otp"] = "Otp salah";
      // this.setState({ errors: errors });
      // return formIsValid
    }

    if (this.state.listToken.indexOf(parseInt(this.state.Model.otp)) != -1) {
      formIsValid = false
      errors["otp"] = "OTP kadaluarsa, silakan kirim ulang OTP"
    } else {
      // console.log(this.state.listToken.indexOf(parseInt(this.state.Model.otp)))
    }

    if ((new Date() > new Date(this.state.token.expired_on)) && (fields["otp"] == fields2['token'])) {
      formIsValid = false;
      errors["otp"] = "OTP kadaluarsa, silakan kirim ulang OTP";
      userService.expToken(this.state.token)
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  handleValidationPass = () => {
    let fields = this.state.Model;
    let errors = {};
    let formIsValid = true;

    //Name
    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "Cannot be empty";
    }

    if (typeof fields["password"] !== "undefined") {
      if (!fields["password"].match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)) {
        formIsValid = false;
        errors["password"] = "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character";
      }
    }

    if (fields["retype_pass"] != fields["password"] && !errors["password"]) {
      formIsValid = false;
      errors["match"] = "Password not match";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  handleValidationDaftar = () => {
    let fields = this.state.Biodata;
    let fields1 = this.state.Model
    let errors = {};
    let formIsValid = true;
    let NotNull = this.state.Biodata.mobile_phone.slice(0, 1)

    //Name
    if (!fields["fullname"]) {
      formIsValid = false;
      errors["fullname"] = "Cannot be empty";
    }
    if (!fields1["role_id"]) {
      formIsValid = false;
      errors["role_id"] = "Harus Pilih 1";
    }


    if (typeof fields["mobile_phone"] !== "undefined") {
      if (!fields["mobile_phone"].match(/^\d{11,}$/)) {
        formIsValid = false;
        errors["mobile_phone"] = "Masukan Nomer telfon dengan benar";
      }
    }

    if (!fields["mobile_phone"]) {
      formIsValid = true;
      errors["mobile_phone"] = "";
    }

    if (NotNull == 0) {
      formIsValid = false;
      errors["mobile_phone"] = "Masukan Nomer telfon dengan benar";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }



  sendOtp = async () => {
    let tmpList = []
    this.setState({
      disabled: true,
      displayCount: '',
      displaySend: 'none',
      errors: {}
    }, async () => {
      const responList = await userService.listExpToken(this.state.Model.email)
      console.log(responList)
      if (responList.success) {
        for (let i = 0; i < responList.result.length; i++) {
          tmpList.push(responList.result[i].token)
        }
        this.setState({
          listToken: tmpList
        }, async () => {
          const responTOK = await userService.expToken(this.state.Model)
          if (responTOK.success) {
            const respon = await userService.sendOtp(this.state.Model)
            this.setState({
              disabled: true
            })
            if (respon.success) {
              const responToken = await userService.insertToken({ email: this.state.Model.email, otp: respon.result })
              // console.log(responToken.result.ops[0])
              if (responToken.success) {
                this.setState({
                  showModalOtp: true,
                  showModalLoad: false,
                  token: responToken.result.ops[0],
                  time: 30,
                  displayCount: '',
                  displaySend: 'none'
                })
                this.interval = setInterval(() => this.updateCountdown(), 1000);
                this.setState({
                  disabled: false
                })
              }
            }
          }
        })
      }
    })
  }

  onKonfirmasi = async () => {
    if (this.handleValidationOTP()) {
      const respon = await userService.expToken(this.state.token)
      if (respon.success) {
        this.setState({
          showModalOtp: false,
          showModalPass: true
        })
        clearInterval(this.interval)
      }
    }
  }

  onSetPassword = async () => {
    if (this.handleValidationPass()) {
      this.setState({
        showModalPass: false,
        ShowModalBio: true
      })
      const respon = await userService.getRole()
      if (respon.success) {
        this.setState({
          ListRole: respon.result
        })
      }
    }
  }

  onDaftar = async () => {
    if (this.handleValidationDaftar()) {
      const respon = await userService.addDataBio(this.state.Biodata)
      if (respon.success) {
        this.setState({
          Model: {
            ...this.state.Model,
            ["biodata_id"]: respon.result.insertedId
          }
        })
        const responAdd = await userService.addData(this.state.Model)
        if (responAdd.success) {
          window.location.reload()
        }
      }
    }
  }

  cancel2Handler = () => {
    this.setState({
      errors: {}
    }, () => { this.props.cancelRegHandler() })
  }

  render() {
    const { errors, showModalOtp, displayCount, displaySend, showModalPass, ShowModalBio, ListRole, Model, showModalLoad } = this.state
    const { ShowModalreg, cancelRegHandler, ModalHandler } = this.props
    return (
      <div>
        {/* {JSON.stringify(this.state.Model)} */}
        <Modal show={ShowModalreg} onHide={this.cancel2Handler}>
          <Modal.Header closeButton>
            <Modal.Title>Daftar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="main-wrapper  account-wrapper">
              <form action="javascript:void(0)" onSubmit={this.onSignUp}>
                <div class="account-logo">
                  <a href="/"><img src="assets/img/logo-dark.png" alt="" /></a>
                </div>
                <div class="form-group">
                  <label>Email Address</label>
                  <input type="email" placeholder="Masukan Email" class="form-control" onChange={this.changeHandler('email')} />
                </div>
                <span className="error">{errors["email"]}</span>
                <span className="error">{errors["Email_NotReady"]}</span>
                <div class="form-group text-center">
                  <button class="btn btn-primary account-btn" type="button" onClick={this.onSignUp} disabled={this.state.disabled}>Send OTP</button>
                </div>
                <div class="text-center login-link">
                  Already have an account? <a href="javascript:void(0)" onClick={ModalHandler}>Login</a>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showModalOtp} onHide={this.cancelHandler}>
          <Modal.Header closeButton>
            <Modal.Title>Email Verifikasi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="main-wrapper  account-wrapper">
              {/* {JSON.stringify(this.state.listToken)} */}
              <form action="javascript:void(0)" onSubmit={this.onKonfirmasi}>
                <div class="account-logo">
                  <a href="/"><img src="assets/img/logo-dark.png" alt="" /></a>
                </div>
                <div class="form-group">
                  <label>OTP</label>
                  <input type="text" placeholder="Masukan OTP" class="form-control" onChange={this.changeHandler('otp')} />
                  <span className="error">{errors["otp"]}</span>
                  {/* <span className="error">{errors["otpkad"]}</span> */}
                </div>

                {/* <span className="error">{errors["email"]}</span> */}
                <div class="form-group text-center">
                  <span style={{ display: `${displayCount}` }}>Kirim ulang kode otp dalam {this.state.minutes}:{this.state.second}</span>
                  <button class="btn btn-primary account-btn" type="button" style={{ display: `${displaySend}` }} onClick={this.sendOtp} disabled={this.state.disabled}>Send OTP</button>
                </div>
                <div class="form-group text-center">
                  <button class="btn btn-primary account-btn" type="button" onClick={this.onKonfirmasi}>Konfirmasi</button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showModalPass} onHide={this.cancelHandlerPass}>
          <Modal.Header closeButton>
            <Modal.Title>Set Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="main-wrapper  account-wrapper">
              <form action="javascript:void(0)" onSubmit={this.onSetPassword}>
                <div class="account-logo">
                  <a href="/"><img src="assets/img/logo-dark.png" alt="" /></a>
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input type="password" placeholder="password" class="form-control" onChange={this.changeHandler('password')} />
                  <span className="error">{errors["password"]}</span>
                </div>
                <div class="form-group">
                  <label>Retype Password</label>
                  <input type="password" placeholder="retype-password" class="form-control" onChange={this.changeHandler('retype_pass')} />
                  <span className="error">{errors["match"]}</span>
                </div>
                <div class="form-group text-center">
                  <button class="btn btn-primary account-btn" type="button" onClick={this.onSetPassword}>set password</button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={ShowModalBio} onHide={this.cancelHandlerBio}>
          <Modal.Header closeButton>
            {/* {JSON.stringify(this.state.Model)}
            {JSON.stringify(this.state.Biodata)} */}
            <Modal.Title>Daftar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="main-wrapper  account-wrapper">
              <form action="javascript:void(0)" onSubmit={this.onDaftar}>
                <div class="account-logo">
                  <a href="/"><img src="assets/img/logo-dark.png" alt="" /></a>
                </div>
                <div class="form-group">
                  <label>Nama Lengkap*</label>
                  <input type="text" placeholder="Nama Lengkap" class="form-control" onChange={this.changeHandlerBio('fullname')} />
                  <span className="error">{errors["fullname"]}</span>
                </div>
                {/* <div class="form-group">
                <label>Nomor Handphone</label>
                <input type="tel" placeholder="081234567890" class="form-control" onChange={this.changeHandlerBio('mobile_phone')} />
                <span className="error">{errors["mobile_phone"]}</span>
              </div> */}
                <label>Nomor Handphone</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">+62</span>
                  </div>
                  <input type="tel" class="form-control" placeholder="81234567890" onChange={this.changeHandlerBio('mobile_phone')} />
                </div>
                <span className="error">{errors["mobile_phone"]}</span>
                <div class="form-group">
                  <label>Daftar Sebagai*</label>
                  <select class="form-control" value={Model.role_id} onChange={this.changeHandler('role_id')}>
                    <option selected hidden>Pilih</option>
                    {
                      ListRole.map(data => {
                        return (
                          <option value={data._id}>{data.name}</option>
                        )
                      })
                    }
                  </select>
                  <span className="error">{errors["role_id"]}</span>
                </div>
                <span className="error">*Harus wajib diisi</span>
                {/* <span className="error">{errors["email"]}</span>
              <span className="error">{errors["Email_NotReady"]}</span> */}
                <div class="form-group text-center">
                  <button class="btn btn-primary account-btn" type="button" onClick={this.onDaftar}>Daftar</button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showModalLoad}>
          <Modal.Header>
            <Modal.Title>Loading...</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="main-wrapper account-wrapper">
              <h1>Sedang mengirim otp</h1>
              <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status" style={{width:"2em",height:"2em",fontSize:"2em"}}>
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}